import { isEmpty } from 'lodash';

import { IBaseEntityType } from '../types';

const isNeedDMSync = (data: IBaseEntityType): boolean => {
  if (isEmpty(data)) {
    return false;
  }

  return !isEmpty(data.updated_items) || !isEmpty(data.unavailable_items);
};

export { isNeedDMSync };
